/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 *
 */
export type EntityMatrixIdentifier = io.TypeOf<typeof MatrixIdentifier>;

export const MatrixIdentifier = io.intersection(
  [
    io.type({
      apiKey: io.string,
      apiUrl: io.string,
      name: io.string,
    }),
    io.partial({ rootAssetId: io.string }),
  ],
  'MatrixIdentifierSettings',
);
